import { render, staticRenderFns } from "./DependentListsTable.vue?vue&type=template&id=11fbbe9a&scoped=true"
import script from "./DependentListsTable.vue?vue&type=script&lang=js"
export * from "./DependentListsTable.vue?vue&type=script&lang=js"
import style0 from "./DependentListsTable.vue?vue&type=style&index=0&id=11fbbe9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fbbe9a",
  null
  
)

export default component.exports